var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43536 15.1229C9.24075 15.3142 8.92874 15.3141 8.73422 15.1228L5.64106 12.0798C5.44697 11.8888 5.13578 11.8883 4.94102 12.0785L4.36485 12.6414C4.16453 12.837 4.16397 13.1591 4.36359 13.3555L8.73406 17.655C8.92864 17.8465 9.24078 17.8465 9.43536 17.655L19.6377 7.61818C19.8368 7.42227 19.8368 7.10121 19.6377 6.90531L19.0679 6.3448C18.8734 6.15344 18.5614 6.15337 18.3668 6.34464L9.43536 15.1229Z",
    fill: "currentColor"
  })));
};
export default SvgCheck;